import { create } from "zustand";
import { persist } from "zustand/middleware";

export type Locale = "ru" | "en";
export type Theme =
  | "default"
  | "ocean"
  | "midnight"
  | "zinc"
  | "rose"
  | "forest"
  | "amber";

export type SidebarCollapsible = "icon" | "offcanvas" | "none";
export type SidebarVariant = "sidebar" | "floating" | "inset";
export type HeaderVariant = "sticky" | "default";
export type DateFormat = "dd:MM:yyyy";

type SettingsState = {
  locale: Locale;
  theme: Theme;
  sidebarCollapsible: SidebarCollapsible;
  sidebarVariant: SidebarVariant;
  isSidebarOpen: boolean;
  headerVariant: HeaderVariant;
  dateFormat: DateFormat;
};

type SettingsActions = {
  setLocale: (locale: Locale) => void;
  setTheme: (theme: Theme) => void;
  setSidebarCollapsible: (sidebarCollapsible: SidebarCollapsible) => void;
  setSidebarVariant: (sidebarVariant: SidebarVariant) => void;
  setSidebarOpen: (isSidebarOpen: boolean) => void;
  setHeaderVariant: (headerVariant: HeaderVariant) => void;
  setDateFormat: (dateFormat: DateFormat) => void;
  reset: () => void;
};

type SettingsStore = SettingsState & SettingsActions;

const defaultSettings: SettingsState = {
  locale: "en",
  theme: "default",
  sidebarCollapsible: "icon",
  sidebarVariant: "inset",
  isSidebarOpen: true,
  headerVariant: "default",
  dateFormat: "dd:MM:yyyy",
};

export const useSettingsStore = create<SettingsStore>()(
  persist(
    (set) => ({
      ...defaultSettings,
      setLocale: (locale) => set({ locale }),
      setTheme: (theme) => set({ theme }),
      setSidebarCollapsible: (sidebarCollapsible) =>
        set({ sidebarCollapsible }),
      setSidebarVariant: (sidebarVariant) => set({ sidebarVariant }),
      setSidebarOpen: (isSidebarOpen) => set({ isSidebarOpen }),
      setHeaderVariant: (headerVariant) => set({ headerVariant }),
      setDateFormat: (dateFormat) => set({ dateFormat }),
      reset: () => set(defaultSettings),
    }),
    {
      name: "skynex-settings",
    }
  )
);
